import { Component, OnInit, ViewChild, TemplateRef, HostListener, Input, Inject, Optional } from '@angular/core';
import { forEach, indexOf, isArray, startsWith } from 'lodash';
import { PlatfromUserAccssManagementService } from '../../services/platform-user-access-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateUserCommand, CountryCode } from '../../models/platform-user-access-management.model';
import { Location } from '@angular/common';
import { first, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UAMProfileImageUploadService } from '../../services/platform-profile-image-upload.service';
import { AppProfileImageDialogComponent } from '../../dialogs/app-profile-image-dialog/app-profile-image-dialog.component';
import { ShellDomainProvider, UtilityService } from '../../../../ecap3/core';
@Component({
    selector: 'app-platform-user-update',
    templateUrl: './platform-user-update.component.html',
    styleUrls: ['./platform-user-update.component.scss'],
    standalone: false
})
export class PlatformUserUpdateComponent implements OnInit {
    userId: any;
    userInfo: UpdateUserCommand;
    userRoles: any = [];
    seletedRole: any = [];
    isMultipleRole: false;
    roleList: any = [];
    rootPath: string;
    personInfo: any;
    defaultRoles: any = ['appuser', 'anonymous'];
    defaultCountryOfPhoneNumber: string = '';
    allowedCountriesOfPhoneNumber: any;
    loading: boolean = false;
    uamViews: any;
    uamConfig: any;
    paramsSubscription: any;
    gender: any = ['Male', 'Female'];
    salutation: any = ['Mr', 'Mrs'];
    profileImageFile: any;
    profileImageFileUrl: any;
    ProfileImageUrl: any;
    updateProfileImage: boolean = false;
    profileDefaultImageUrl: string =
        ShellDomainProvider['api'].CdnBaseUrl + 'swica/assets/images/profile-default-1.svg';
    @ViewChild('profileImage', { static: true }) profileImageElem: any;
    constructor(
        private platfromUserAccssManagementService: PlatfromUserAccssManagementService,
        private router: Router,
        private _location: Location,
        private snackBar: MatSnackBar,
        private translateService: TranslateService,
        private activatedRoute: ActivatedRoute,
        @Optional() @Inject('IAppPlatformUserAccessManagement') private IAppPlatformUserAccessManagement,
        private dialog: MatDialog,
        private UAMProfileImageUploadService: UAMProfileImageUploadService,
        private utilityService: UtilityService
    ) {
        this.userInfo = new UpdateUserCommand();
        let countries = new CountryCode();
        this.allowedCountriesOfPhoneNumber = countries && countries.countryCode;
    }

    ngOnInit() {
        this.uamViews = this.platfromUserAccssManagementService.getViews();
        this.uamConfig = this.platfromUserAccssManagementService.getUamConfig();
        this.paramsSubscription = this.activatedRoute.queryParams.subscribe(params => {
            this.userId = (params && params['userId']) || null;
            if (this.userId) {
                this.getUserInfoById();
                this.getRoles();
            }
        });
        this.activatedRoute.queryParams.subscribe(params => {
            this.rootPath = params && params['root'];
        });

        this.updateProfileImage =
            (this.uamConfig &&
                this.uamConfig.ProfileImageConfig &&
                this.uamConfig.ProfileImageConfig.UpdateProfileImage) ||
            false;
        if (this.uamConfig && this.uamConfig.ProfileImageConfig && this.uamConfig.ProfileImageConfig.DefaultImageUrl) {
            this.profileDefaultImageUrl = this.uamConfig.DefaultImageUrl;
        }
    }

    getUserInfoById() {
        this.platfromUserAccssManagementService.getUserInfoById(this.userId).subscribe(responseUserInfo => {
            this.userInfo = responseUserInfo && new UpdateUserCommand(responseUserInfo.User);
            this.getPersonInfoOfUser();
            forEach(this.userInfo.Roles, role => {
                if (indexOf(this.defaultRoles, role) == -1) {
                    this.seletedRole = role;
                    // this.roleList.push(role.RoleName);
                }
            });
        });
    }
    getPersonInfoOfUser() {
        if (this.uamConfig && this.uamConfig.needExtraUserInfo) {
            let personsProperty =
                this.uamConfig && this.uamConfig.PropertyFromPerson ? this.uamConfig.PropertyFromPerson : [];
            indexOf(personsProperty, 'CreatedBy') > -1 ? personsProperty : personsProperty.push('CreatedBy');
            indexOf(personsProperty, 'ProfileImageId') > -1 ? personsProperty : personsProperty.push('ProfileImageId');
            this.IAppPlatformUserAccessManagement.getPersonInfoOfUser(this.userInfo, personsProperty).subscribe(
                (responseUserInfo: any) => {
                    this.personInfo =
                        (responseUserInfo &&
                            responseUserInfo.Results &&
                            responseUserInfo.Results.length &&
                            responseUserInfo.Results[0]) ||
                        {};
                    if (
                        this.uamConfig &&
                        this.uamConfig.ProfileImageConfig &&
                        this.uamConfig.ProfileImageConfig.UpdateProfileImage
                    ) {
                        this.getProfileImageOfPerson();
                    }
                    forEach(this.uamConfig && this.uamConfig.PropertyFromPerson, personProperty => {
                        if (responseUserInfo && responseUserInfo[personProperty]) {
                            this.userInfo[personProperty] = responseUserInfo && responseUserInfo[personProperty];
                        }
                    });
                }
            );
        }
        // this.platfromUserAccssManagementService.getPersonByUserId(this.userId).subscribe(response => {
        //     this.personInfo = response && new UpdateUserCommand(response && response.Results && response.Results[0]);
        //     if(this.personInfo){
        //         this.userInfo.FirstName = this.personInfo.FirstName;
        //         this.userInfo.LastName = this.personInfo.LastName;
        //         this.userInfo.Salutation = this.personInfo.Salutation;
        //         this.userInfo.Sex = response && response.Results && response.Results[0]['Sex'];
        //     }
        // });
    }
    getRoles() {
        this.platfromUserAccssManagementService.getUsersRoles([]).subscribe(responseRoles => {
            forEach(responseRoles && responseRoles.Roles, role => {
                if (indexOf(this.defaultRoles, role.RoleName) == -1) {
                    this.roleList.push(role.RoleName);
                }
            });
        });
    }
    onSelectionChange(role) {
        this.seletedRole = role.value;
    }

    updateUser() {
        this.loading = true;
        let updateUser = this.getUpdateUser();
        updateUser = this.getDisplayName();
        if (updateUser['Sex'] && this.personInfo) {
            let personInfo = {
                ItemId: this.personInfo['ItemId'],
                Sex: updateUser['Sex']
            };
            this.platfromUserAccssManagementService.updatePerson(personInfo).pipe(first()).subscribe();
        }
        updateUser = this.platfromUserAccssManagementService.updateUserWithPersonInfo(updateUser);
        this.platfromUserAccssManagementService.updateUser(updateUser).subscribe(response => {
            if (this.profileImageFile && this.personInfo && this.personInfo.ItemId) {
                this.UAMProfileImageUploadService.uploadProfileImage(
                    this.personInfo && this.personInfo.ItemId,
                    this.profileImageFile,
                    this.uamConfig
                ).subscribe(response => {
                    this.loading = false;
                    this.routeToUserList();
                });
            } else {
                this.loading = false;
                this.routeToUserList();
            }
        });
    }

    getUpdateUser() {
        if (isArray(this.seletedRole)) {
            this.userInfo.Roles = [];
            forEach(this.seletedRole, role => {
                this.userInfo.Roles.push(role);
            });
        } else {
            this.userInfo.Roles = [];
            this.userInfo.Roles.push(this.seletedRole);
        }
        forEach(this.defaultRoles, role => {
            indexOf(this.userInfo && this.userInfo.Roles, role) > -1 ? null : this.userInfo.Roles.push(role);
        });
        this.userInfo.PhoneNumber = this.getValidPhoneNumber();
        return this.userInfo;
    }
    getValidPhoneNumber() {
        if (this.userInfo.PhoneNumber) {
            if (startsWith(this.userInfo.PhoneNumber, '+')) return this.userInfo.PhoneNumber;
            else {
                return '+' + this.userInfo.PhoneNumber;
            }
        }
        return '';
    }
    getDisplayName() {
        if (this.userInfo.FirstName != '') {
            this.userInfo.DisplayName = this.userInfo.FirstName + ' ' + this.userInfo.LastName;
        }
        return this.userInfo;
    }

    routeToUserList() {
        this._location.back();
        // this.router.navigate([this.rootPath]);
    }

    setTwofactorAuthentication() {
        this.userInfo.TwoFactorEnabled = !this.userInfo.TwoFactorEnabled;
        this.showMessage();
    }
    showMessage() {
        this.translateService
            .get('UPDATE_TWO_FACTOR_AUTHENTICATION')
            .pipe(take(1))
            .subscribe((message: string) => {
                if (message !== 'UPDATE_TWO_FACTOR_AUTHENTICATION') {
                    this.snackBar.open(message, null, { duration: 1000 });
                }
            });
    }

    openProfileImageDialog() {
        const dialogRef = this.dialog.open(AppProfileImageDialogComponent, {
            panelClass: 'swica-dialog',
            width: '100vw',
            maxWidth: '550px',
            data: this.personInfo
        });

        dialogRef.afterClosed().subscribe(profileImage => {
            if (profileImage) {
                this.profileImageFile = profileImage;
                this.profileImageFileUrl = window.URL.createObjectURL(this.profileImageFile);
                this.showProfileImage();
                // document.querySelector("#image")["style"]["background-image"] = 'url(' + this.profileImageFileUrl + ")";
            }
        });
    }
    getProfileImageOfPerson() {
        if (this.personInfo && this.personInfo.ProfileImageId) {
            this.UAMProfileImageUploadService.getProfileImageOfPerson(
                this.personInfo && this.personInfo.ProfileImageId
            ).subscribe(response => {
                this.profileImageFileUrl = response && response.Url;
                this.showProfileImage();
            });
        }
    }

    showProfileImage() {
        document.querySelector('#image')['style']['background-image'] = 'url(' + this.profileImageFileUrl + ')';
    }

    ngOnDestroy(): void {
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
    }
}
